import React, { FC } from 'react';
import { IonMenuButton } from '@ionic/react';

export interface AllieMenuButtonProps {
  menu?: string;
  autoHide?: boolean;
  disabled?: boolean;
  className?: string;
  color?: string;
  'data-testid'?: string;
  onClick?: () => void;
}

/**
 * AllieMenuButton - Wrapper around IonMenuButton
 * Provides consistent menu button styling and behavior
 */
export const AllieMenuButton: FC<AllieMenuButtonProps> = ({
  menu,
  autoHide = true,
  disabled = false,
  className,
  color,
  'data-testid': dataTestId,
  onClick,
}) => {
  return (
    <IonMenuButton
      menu={menu}
      autoHide={autoHide}
      disabled={disabled}
      className={className}
      color={color}
      data-testid={dataTestId}
      onClick={onClick}
    />
  );
};

AllieMenuButton.displayName = 'AllieMenuButton';
